export default __webpack_public_path__ + "static/Graphik-Regular-Web-8fcac4f3b9dfa9b548dde7a0645488f3.woff2";